export default __webpack_public_path__ + "static/media/bubbleBg.df02c38f.png";